export default __webpack_public_path__ + "static/media/ISF_gray.70e5b499.svg";